import React, { useEffect } from "react";
import { Sidebar } from "primereact/sidebar";
import foodGIF from "../../../assets/food/food.gif";
import { ProceedButton } from "src/styled-components/generalTags";
import FlexiLogo from "../../../assets/flexi/FLEXISHOW-LOGO-WHITE.svg";
import cross from "../../../assets/flexi/cross.svg";
import inoxpvrst from "../../../assets/super-ticket/inox-st.png";
import dummy from "../../../assets/super-ticket/dummy.png";
//import "./superticketPopup.css";

function Familybundlehowitwork({ visible, content, setVisible }) {
  const theme = localStorage.getItem("theme");
  const isMobile = window.matchMedia("(max-width: 575px)").matches;

  useEffect(() => {

  }, [visible]);
  return (
    <div>
      <Sidebar
        visible={visible}
        showCloseIcon={false}
        position={isMobile ? "bottom" : "right"}
        className="flexi-terms-cond"
        style={{ height: "95vh" }}
        onHide={() => {
          setVisible(false);
        }}
        dismissable={true}>
        <div className="flexi-cross-how d-flex justify-content-between">
          <h2>{content?.header}</h2>
          <img src={cross} alt="" className="img-fluid" onClick={() => {
            setVisible(false);
          }} />
        </div>
        <div className="row mt-2">
          <div className="container">
            <div className="col-lg-12 col-sm-12">
              {/* <p>Curious About F&B Bundle Code ?</p> */}
              <img src={content?.voucherData?.faqImageUrl} className="img-fluid" />
              <div className="st-hiw-button-box">
                <ProceedButton className="how-it-okay" onClick={() => {
                  setVisible(false);
                }}>
                  Okay
                </ProceedButton>
              </div>
            </div>
          </div>
        </div>

      </Sidebar>
    </div>
  );
}

export default Familybundlehowitwork;
